/* eslint-disable @typescript-eslint/no-unused-vars */
import React from "react";
import StatWrapper from "../shared/StatWrapper";
import Icon from "hardcover-ui/components/Icon";
import BookIcon from "icons/solid/book.svg";
import HeadphonesIcon from "icons/solid/headphones.svg";
import UserIcon from "icons/solid/user-shakespeare.svg";
import LightbulbIcon from "icons/solid/lightbulb.svg";
import StarIcon from "icons/solid/star.svg";
import PencilIcon from "icons/solid/pencil.svg";
import PagesIcon from "icons/solid/book-open.svg";
import StatPeriodSelect from "../StatPeriodSelect";
import Heading from "hardcover-ui/components/Heading";
import { Period } from "../StatPeriodContext";
import { usePage } from "@inertiajs/react";
import { UserStatsPageProps } from "pages/clientverse/users/stats/index.props";
import LocaleNumber from "components/ui/LocaleNumber";
import { StatsSerializersSummary } from "types/serializers";
import Text from "hardcover-ui/components/Text";

const dataMap = [
  {
    icon: BookIcon,
    label: "Books Read",
    key: "booksRead",
  },
  {
    icon: PagesIcon,
    label: "Pages Read",
    key: "pagesRead",
  },
  {
    icon: HeadphonesIcon,
    label: "Hours Listened",
    key: "hoursListened",
  },
  {
    icon: UserIcon,
    label: "Authors Read",
    key: "authorsReadCount",
  },
  {
    icon: LightbulbIcon,
    label: "Inspired reads",
    key: "inspiredReadsCount",
  },
  {
    icon: StarIcon,
    label: "Reviews",
    key: "reviewsCount",
  },
  // TODO: #1496 - Get data returned from backend
  // {
  //   icon: PencilIcon,
  //   label: "Librarian edits",
  //   key: "librarianEditsCount",
  // },
];

const chartData = [
  {
    id: "reading",
    data: Array.from({ length: 20 }, (_, i) => ({
      x: i,
      y: Math.sin(i * 0.5) * 50 + 50 + Math.random() * 10,
    })),
  },
];

interface SummaryStatProps {
  size?: "sm" | "md" | "lg" | "xl";
}

function BackgroundChart() {
  return (
    <div className="absolute inset-0 opacity-20 pointer-events-none overflow-hidden rounded-lg">
      <div className="absolute -inset-4">
        <p className="hidden">RESPONSIVE LINE HERE</p>
        {/* <ResponsiveLine
          data={chartData}
          margin={{ top: 40, right: 0, bottom: 0, left: 0 }}
          xScale={{ type: "linear" }}
          yScale={{ type: "linear", min: 0, max: 100 }}
          curve="monotoneX"
          axisTop={null}
          axisRight={null}
          axisBottom={null}
          axisLeft={null}
          enableGridX={false}
          enableGridY={false}
          enablePoints={false}
          enableArea={true}
          areaOpacity={0.15}
          isInteractive={false}
          animate={false}
          colors={{ scheme: "category10" }}
          lineWidth={2}
        /> */}
      </div>
    </div>
  );
}

function Content({ data }: { data: StatsSerializersSummary }) {
  if (!data) {
    return (
      <div className="relative z-10 p-4">
        <Text variant="secondary">No summary data available</Text>
      </div>
    );
  }

  return (
    <div className="relative z-10 p-4">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-2">
        {dataMap.map((item) => {
          const value = data[item.key] || 0;
          return (
            <div key={item.label} className="flex items-center gap-2">
              <Text variant="secondary">
                <Icon icon={item.icon} className="mr-1 w-5 h-5" />
              </Text>
              <div className="flex flex-col">
                <p className="text-2xl lg:text-4xl font-bold">
                  <LocaleNumber number={value} />
                </p>
                <Text variant="secondary" as="p" className="text-sm lg:text-base capitalize">{item.label}</Text>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default function SummaryStat({ size }: SummaryStatProps) {
  const { user, stats } = usePage<UserStatsPageProps>().props;

  if (!user || !stats || !stats.summary) {
    return (
      <StatWrapper title="Summary" size={size} noPadding gradient noDropdown>
        <div className="w-full h-full relative pb-6">
          <Text variant="secondary">No summary data available</Text>
        </div>
      </StatWrapper>
    );
  }

  return (
    <StatWrapper
      title={
        <div className="flex flex-col md:flex-row md:items-center gap-2 p-4 pt-8">
          <Heading size="xl">{user.name || "User"}'s</Heading>
          <StatPeriodSelect
            buttonClassName="border border-secondary rounded-md bg-transparent"
            textClassName="text-4xl font-serif"
          />
          <Heading size="xl">in Books</Heading>
        </div>
      }
      size={size}
      noPadding
      gradient
      noDropdown
    >
      <div className="w-full h-full relative pb-6">
        <BackgroundChart />
        <Content data={stats.summary} />
      </div>
    </StatWrapper>
  );
}
